import moment from 'moment';
import { isMobile } from 'react-device-detect';

import { Match } from 'models/Match';

import { Request } from 'components/Request';
import { Dashboard } from 'components/Dashboard';

import store from 'react/redux/store/store';
import * as matchmakingActions from 'react/redux/actions/matchmaking';
import { netplayLinkedContinents } from 'react/netplay/netplayPageState';

class MatchSearchList {
	constructor(matchSearchListManager, name, matchBelongsToThisListCallback) {
		this.matchSearchListManager = matchSearchListManager;
		this.name = name;
		this.matchBelongsToThisListCallback = matchBelongsToThisListCallback;
		this.matches = new Map();

		this.pendingSort = null;
		this.matchesToRemove = [];
		this.hiddenSearches = new Map();

		this.sortLocks = new Map();
		this.attachedChildren = {};

		this.myInitiationsByParent = new Map();
		this.myInitiationsByChild = new Map();

		// Temporary list that is used to store a reference so that missed challenges can be used
		this.matchesThatGotRemoved = {};
		this.makeSureThingsDoNotDieInterval = null;

		this.matchBelongsToThisList = this.matchBelongsToThisList.bind(this);

		this.makeSureListSortsAndSuchEverySoEvenWhenInactive();
	}

	makeSureListSortsAndSuchEverySoEvenWhenInactive() {
		if(this.makeSureThingsDoNotDieInterval) {
			clearInterval(this.makeSureThingsDoNotDieInterval);
		}
		this.makeSureThingsDoNotDieInterval = setInterval(() => {
			this.clearSortLocks();
			this.updatedList({ triggerChange: true });
		}, 60000);
	}

	clear() {
		this.matches.clear();
		this.pendingSort = null;
		this.matchesToRemove = [];
	}

	staticList() {
		this.makeSureListSortsAndSuchEverySoEvenWhenInactive();
		if(this.pendingSort) {
			this.initiateSort();
		}
		const theMatchList = new Map();
		this.hiddenSearches.clear();
		for(let [_, match] of this.matches) {
			if(!match.searchIsVisible()) {
				this.hiddenSearches.set(match.id, match);
				continue;
			}
			if(this.myInitiationsByParent.has(match.id)) {
				theMatchList.set(match.id, this.myInitiationsByParent.get(match.id)); // Place child instead of parent search...
			}
			else {
				const myInitiation = this.myInitiationsByChild.get(match.id);
				if(myInitiation && this.matches.has(myInitiation.parent_match_id)) {
				}
				else {
					theMatchList.set(match.id, match); //
				}
			}
		}
		return Array.from(theMatchList);
	}

	updatedList() {
		this.removePendingMatches({ triggerChange: true });
		return this.staticList();
	}

	removePendingMatches({ triggerChange } = { triggerChange: false }) {
		while(this.matchesToRemove.length > 0) {
			const match = this.matchesToRemove.pop();
			for(let player of match.getPlayers()) {
				player.now_searching.delete(match.id);
			}
			this.removeMatchFromList(match.id, triggerChange);
		}
	}

	checkMatches({ instantlyRemove: instantlyRemove } = { instantlyRemove: false }) {
		const now = moment();
		for(let [_, match] of this.matches) {
			if(!match.searchTimeEnd) {
				console.error('somehow match had no search time');
				console.log(match);
			}
			if(match.searchTimeEnd === true) {
				continue;
			}
			if(match.searchTimeEnd.isBefore(now)) {
				match.timedOut = true;
				this.removeMatch({ match: match.id, instantlyRemove: instantlyRemove });
			}
		}

	}

	removeMatch({ match: incomingMatchData, updateLists, instantlyRemove } = {
		match: null,
		updateLists: true,
		instantlyRemove: false
	}) {
		let match = null;
		if(incomingMatchData instanceof Match) {
			match = incomingMatchData;
		}
		else if(incomingMatchData.id) {
			const tempMatch = Match.create({ id: incomingMatchData.id });
			const previousMatch = this.matches.get(tempMatch.id);
			if(previousMatch) {
				previousMatch.update(incomingMatchData); //So that we can have accepeted players and such
				match = previousMatch;
			}
			else {
				match = tempMatch;
			}
		}
		else {
			const tempMatch = Match.create({ id: incomingMatchData });
			match = this.matches.get(tempMatch.id);
		}
		if(!match) {
			console.log('match not found');
			return;
		}
		if(match.closed_reason || match.accepted_players.size > 0) {
			match.is_removed = true;
			setTimeout(() => {
				this.matchesToRemove.push(match);
			}, 3000);

			for(let player of match.accepted_players) {
				player.active_match_id = match.id;
			}
		}
		else {
			this.matchesToRemove.push(match);
			if(instantlyRemove) {
				this.removePendingMatches({ triggerChange: false });
			}
		}
		if(updateLists && !instantlyRemove) {
			this.matchListChanged();
		}
	}

	getMatchFromMatchData(matchData) {
		const tempMatch = Match.create({ id: matchData.id });
		if(this.matches.get(tempMatch.id)) {
			return this.matches.get(tempMatch.id);
		}
		return null;
	}

	updateMatch(match) {
		const tempMatch = Match.create({ id: match.id });
		if(this.matches.get(tempMatch.id)) {
			match = this.matches.get(tempMatch.id).update(match);
		}
		else {
			if(!(match instanceof Match)) {
				match = Match.create(match);
			}
			if(match.id) {
				if(match.is_removed) {
					this.removeMatch({ match: tempMatch, updateLists: true });
					// console.log('remove ',tempMatch);
					return;
				}
				if(!match.ladder) {
					return;
				}
				if(match.start_time) {
					return;
				}
				const mainPlayer = match.mainPlayer;
				if(mainPlayer) {
					mainPlayer.now_searching.set(match.id, match);
					if(myUser.ignore_list[mainPlayer.id]) {
						return;
					}
				}
				this.addMatchToList(match);
				this._newMatchInListChecks(match);
				this.pendingSort = true;
			}
		}
		if(match.is_removed) {
			this.removeMatch({ match: match, updateLists: false });
		}
		this.matchListChanged();
	}

	sortLockMatch(match, setSortLock) {
		if(setSortLock) {
			this.sortLocks.set(match.id, true);
		}
		else {
			this.sortLocks.delete(match.id);
		}
		this.pendingSort = true;
	}

	hasSortLock(match) {
		return this.sortLocks.has(match.id);
	}

	clearSortLocks() {
		this.sortLocks.clear();
		this.pendingSort = true;
	}

	setInitialSortLock(hoveredMatch) {
		this.sortLocks.clear();
		for(let [i, match] of this.matches) {
			this.sortLockMatch(match, true);
			if(hoveredMatch && match.id === hoveredMatch.id) {
				break;
			}
		}
	}

	addMatchToList(match, triggerChange = true) {
		this.matches.set(match.id, match);
		delete this.matchesThatGotRemoved[match.id];
		if(triggerChange) {
			this.matchListChanged();
		}
	}

	removeMatchFromList(matchId, triggerChange = true) {
		const matchToBeRemoved = this.matches.get(matchId);
		const result = this.matches.delete(matchId);
		this.pendingSort = true;
		if(this.attachedChildren[matchId]) {
			delete this.attachedChildren[matchId];
		}
		if(matchToBeRemoved) {
			this.matchesThatGotRemoved[matchId] = matchToBeRemoved;
		}
		if(triggerChange) {
			this.matchListChanged();
		}

		return result;
	}

	matchListChanged() {
		this.pendingSort = true; // Experimental, maybe this will force more updates and possibly fix the bug where a peron's own search will not appear
		store.dispatch(matchmakingActions.matchmakingListUpdated(this.name, this.matches, this.matchesThatGotRemoved));
		this.matchesThatGotRemoved = {};
	}

	initiateSort() {
		if(!this.pendingSort) {
			return;
		}
		const staticMatches = [];
		const sortableMatches = [];
		const myChallenges = new Map();
		this.myInitiationsByChild.clear();
		this.myInitiationsByParent.clear();

		this.matches.forEach((match) => { // Figure out each Challenge I created so that we can attempt to replace "preexisting" searches
			if(match.parent_match_id && match.player2 && match.player2.isMe()) {
				this.myInitiationsByParent.set(match.parent_match_id, match);
				this.myInitiationsByChild.set(match.id, match);
			}
		});
		this.matches.forEach((match) => { // Establish which matches are sortable and which ones should stay locked due to cursor position
			if(!match.mainPlayer.isMe() && match.containsPlayer(myUser)) {
				myChallenges.set(match.id, match);
			}
			let list = null;
			if(this.sortLocks.has(match.id)) {
				list = staticMatches;
			}
			else {
				list = sortableMatches;
			}
			if(this.myInitiationsByParent.has(match.id)) { //So that we can easily place our challenge on top of the previous search
				list.push(this.myInitiationsByParent.get(match.id));
			}
			list.push(match);
		});

		sortableMatches.sort((a, b) => {
			return this.compareMatches(a, b);
		});
		this.matches.clear();

		// Only thing special here is that "Attached children" WILL get sorted improperly, so we keep them locked in place
		staticMatches.forEach((match) => {
			this.addMatchToList(match, false);
			if(this.attachedChildren[match.id]) {
				this.attachedChildren[match.id].forEach((childMatch) => {
					if(!myChallenges.has(childMatch.id)) {
						return;
					}
					this.addMatchToList(childMatch, false);
					myChallenges.delete(childMatch.id);
				});
			}
		});
		sortableMatches.forEach((match) => {
			this.addMatchToList(match, false);

			myChallenges.forEach((challenge) => {
				if(match === challenge) {
					return;
				}
				if(!match.mainPlayer.isMe()) {
					return;
				}
				if(match.hasSameBasicSetup(challenge)) {
					if(!this.attachedChildren[match.id]) {
						this.attachedChildren[match.id] = [];
					}
					this.removeMatchFromList(challenge.id, false);
					this.addMatchToList(challenge, false);
					myChallenges.delete(challenge.id);
					this.attachedChildren[match.id].push(challenge);
				}
			});
		});
		this.pendingSort = false;
	}

	matchBelongsToThisList(match) {
		return this.matchBelongsToThisListCallback(match);
	}

	getMatchWithCriteria({ players, ladderId, gameCount, isRanked, teamSize, exclude, isSearch = false }) {
		for(let match of this.matches.values()) {
			if(exclude && match.id === exclude.id) {
				continue;
			}
			if(match.is_removed) {
				continue;
			}
			let hasAllPlayers = true;
			for(let player of players) {
				if(!match.containsPlayer(player)) {
					hasAllPlayers = false;
				}
			}

			if(isSearch !== null) {
				if(isSearch) {
					if(!match.isSearch) {
						continue;
					}
				}
				else {
					if(match.isSearch) {
						continue;
					}
				}
			}

			if(!hasAllPlayers) {
				continue;
			}

			if(!match.hasSameBasicSetup({
				ladder_id: ladderId,
				match_count: gameCount,
				is_ranked: isRanked,
				team_size: teamSize
			})) {
				continue;
			}
			return match;
		}
	}

	compareMatches(aMatch, bMatch) {
		if(aMatch.containsMeAsPlayer() && !bMatch.containsMeAsPlayer()) {
			return -1;
		}
		if(bMatch.containsMeAsPlayer() && !aMatch.containsMeAsPlayer()) {
			return 1;
		}
		if(aMatch.isSearch && !bMatch.isSearch) {
			return 1;
		}
		if(bMatch.isSearch && !aMatch.isSearch) {
			return -1;
		}
		if(aMatch.getDistance() > bMatch.getDistance()) {
			return 1;
		}
		if(aMatch.getDistance() < bMatch.getDistance()) {
			return -1;
		}
		return 0;
	}

	endMatchmaking(matchId) {
		const data = { match_id: matchId };
		this.removeMatch({ match: matchId, instantlyRemove: true });
		this.matchListChanged();
		return Request.apiv1('matchmaking/end', data);
	}

	_newMatchInListChecks(match) {
		Dashboard.updateSearchBasedOnUserSettings(match);
		this._checkForSearchStartedAlerts(match);
		MatchSearchList._checkForChallengeAlerts(match);
	}

	static _checkForChallengeAlerts(match) {
		if(match.isSearch) {
			return;
		}
		if(match.player1 && match.player2 && match.player2.isMe()) {
			return;
		}
		match.showWantsToPlayNotification(match.notification);
	}

	_checkForSearchStartedAlerts(match) {
		if(!match.isSearch) {
			return;
		}
		if(!this.matchSearchListManager.getCurrentMatch() && myUser.getSearchNotifications().hasNotification(match)) {
			if(match.player1.isMe()) {
			}
			else if(!match.location) {
			}
			else if(!match.location.distanceFromUser) {
			}
			else if(!match.searchIsVisible()) {
			}
			else if(match.gameData.preferred_distance_matters && netplayLinkedContinents().usersHaveLinkedContinents(match.mainPlayer, myUser)) {
				if(!isMobile) {
					match.showSimilarSearchBrowserNotification();
				}
			}
		}
	}

}

export { MatchSearchList };